import { useTranslation } from '@e-kyc/translations';

import { Button, CameraAltOutlinedIcon, Modal } from '../../../../../../components';
import type { EkycStep } from '../../../../../../providers';

interface IdCardConfirmationRetakeProps {
  isOpen: boolean;
  setStep: (step: EkycStep) => void;
  close: () => void;
}

function IdCardConfirmationRetakeModal(props: Readonly<IdCardConfirmationRetakeProps>) {
  const { isOpen, setStep, close } = props;

  const { t } = useTranslation();

  return (
    <Modal open={isOpen} className='w-full max-w-[343px]'>
      <div className='flex w-full flex-col items-center justify-center'>
        <div className='flex flex-col items-center justify-center gap-4 p-6 pt-10'>
          <CameraAltOutlinedIcon className='text-primary-500 text-[48px]' />
          <div className='flex flex-col items-center justify-center gap-2'>
            <h5 className='font-semibold'>{t('idCardDetails.modal.retake.title')}</h5>
            <div className='text-body-1 text-text-secondary'>
              {t('idCardDetails.modal.retake.description')}
            </div>
          </div>
        </div>
        <div className='flex w-full flex-col gap-2 p-4'>
          <Button
            className='w-full'
            onClick={() => {
              setStep('capture-id-card-front');
            }}
          >
            {t('button.confirm')}
          </Button>
          <Button
            className='w-full'
            variant='outlined'
            onClick={() => {
              close();
            }}
          >
            {t('button.cancel')}
          </Button>
        </div>
      </div>
    </Modal>
  );
}

export default IdCardConfirmationRetakeModal;
